<script setup lang="ts">
/**
 * La contraseña pasó a ser una pestaña del modo edición del perfil: cambiarla
 * es editar tu perfil, no visitar una sección del portal. Esta ruta queda solo
 * para no romper enlaces guardados, y llega directo a esa pestaña.
 */
definePage({
  meta: { requiresAuth: true },
  redirect: { name: 'settings-profile', query: { tab: 'security' } },
});
</script>

<template>
  <div />
</template>
